(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ld-tutorial-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var wrappers = document.querySelectorAll('.ld-tutorial-video-wrapper[data-ld-tutorial-redirect="true"]');
  if (!wrappers.length) return;

  wrappers.forEach(function(wrapper) {
    var url = wrapper.getAttribute('data-ld-tutorial-redirect-url');
    if (!url) return;

    var targets = [wrapper];
    var button = wrapper.querySelector('.ld-tutorial-play-button');
    if (button) {
      targets.push(button);
    }

    targets.forEach(function(target) {
      target.addEventListener('click', function(event) {
        event.preventDefault();
        window.location.href = url;
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
